<template>
    <div>
        <div class="inners">
            <div class="par1">
                <div class="ips flx alc">
                    <span>时间范围:</span>
                    <el-date-picker v-model="value2" type="datetimerange" :picker-options="pickerOptions"
                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right"
                        format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm">
                    </el-date-picker>
                </div>
            </div>
            <div class="par1 flx jsb">
                <div class="ips flx alc">
                    <span>搜索订单:</span>
                    <el-input style="width: 374px;" v-model="keywords" placeholder="请输入订单号/活动名"></el-input>
                </div>
                <el-button type="primary" @click="searchResult">搜索</el-button>
            </div>
            <el-tabs v-model="cur" @tab-click="handleClick">
                <el-tab-pane label="全部订单" name="100"></el-tab-pane>
                <el-tab-pane label="待付款" name="0"></el-tab-pane>
                <el-tab-pane label="待参与" name="1"></el-tab-pane>
                <el-tab-pane label="已完成" name="2"></el-tab-pane>
                <el-tab-pane label="已取消" name="3"></el-tab-pane>
                <el-tab-pane label="已退款" name="4"></el-tab-pane>
            </el-tabs>
            <div class="orderTitles flx alc">
                <div class="orderTitle1">
                    订单详情
                </div>
                <div class="orderTitle2">
                    订单用户
                </div>
                <div class="orderTitle3">
                    金额
                </div>
                <div class="orderTitle3">
                    订单状态
                </div>
                <div class="orderTitle4">
                    操作
                </div>
            </div>
            <div class="details">

                <div class="ordersContent">

                    <div class="orderItems">
                        <div class="orderItem" v-for="item,index in list">
                            <div class="orderTit flx alc">
                                <div v-text="item.activity_createtime_text" style="margin-right: 24px;"></div>
                                <div v-text="`订单号:${item.activity_order_no}`"></div>
                            </div>
                            <div class="orderContent flx">
                                <div class="orderc1 flx">
                                    <div class="orderImage">
                                        <img :src="$img(item.activity_avatar)" alt="" />
                                    </div>
                                    <div class="orderGoodsName" v-text="item.activity_name"></div>
                                    <div class="ordernum">
                                        ×1
                                    </div>
                                </div>
                                <div class="orderc3" v-text="item.tel">

                                </div>
                                <div class="orderc2">
                                    <div class="topor" v-text="`￥${item.total_price}`"></div>
                                    <div class="botor">
                                        微信支付
                                    </div>
                                </div>

                                <div class="orderc3">
                                    <div class="topor" style="color: #666666;" v-text="`${item.order_status_text}`">
                                    </div>
                                    <div class="botor cursor" @click="toaorder(item)">
                                        订单详情 &gt;
                                    </div>
                                </div>
                                <div class="orderc4">
                                    <div class="btstyle1 cursor" @click="dialogVisible = true,orderid = item.id"
                                        v-if="item.order_status == 1 && item.total_price*1>0">
                                        退款
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <el-pagination :hide-on-single-page="true" :page-size="50" layout="prev, pager, next" @current-change="pagechenage" :total="total">
                </el-pagination>
                <el-dialog title="提示" :visible.sync="dialogVisible" width="20%">
                    <span>确认为该顾客退款?</span>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="dialogVisible = false">取 消</el-button>
                        <el-button type="primary" @click="refunds">确 定</el-button>
                    </span>
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        signpeople,
        refundmoney
    } from "@/api/index.js"
    export default {
        name: "asideAc",
        data() {
            return {
                dialogVisible: false,
                total: 0,
                cur: '100',
                list: [],
                orderid: "",
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                value2: '',
                keywords: '',
                page: 1
            };
        },
        created() {
            console.log(1313123)
            let that = this
            that.getList()
        },
        activated() {

        },
        methods: {
            pagechenage(e){
                console.log(e)
                this.page= e
                this.getList()
            },
            toaorder(e){
                this.$router.push({
                    path: '/orderDetail', // 写路由path
                    query: {
                       id:e.id
                    }
                })
            },
            refunds(e) {
                let that = this
                let data = that.orderid
                refundmoney(data).then((res) => {
                    if (res.code == 1) {
                        that.$message.success(res.msg)
                        that.getList()
                    } else {
                        that.$message.error(res.msg)
                    }
                })
            },
            searchResult(e) {
                let that = this
                that.page = 1
                that.list = []
                that.getList()
            },
            handleClick(e) {
                console.log("e", e)
                this.page = 1
                this.getList()
            },
            getList() {
                let that = this
                let data = {}
                data.page = that.page
                data.size = 50
                data.source = 'activity'
                data.begin_time = that.value2[0] || ''
                data.over_time = that.value2[1] || ''
                data.keywords = that.keywords
                data.order_status = that.cur
                signpeople(data).then((res) => {
                    console.log(res)
                    if (res.code == 1) {
                        that.list = res.data.list.data
                        that.total = res.data.list.total
                    }
                })
            }
        }
    };
</script>
<style scoped>
    .inners {
        width: 100%;
        box-sizing: border-box;
        padding: 20px;
    }

    .par1 {
        margin-bottom: 24px;
    }

    .ips span {
        font-size: 14px;
        color: #48576A;
        margin-right: 20px;
    }

    .btstyle2 {
        font-size: 12px;
        color: #666666;
        line-height: 21px;
        margin-top: 6px;
        cursor: pointer;
    }

    .btstyle1 {
        width: 74px;
        height: 24px;
        border-radius: 2px 2px 2px 2px;
        border: 1px solid #E4393C;
        color: #E4393C;
        text-align: center;
        line-height: 24px;
        font-size: 12px;
        cursor: pointer;
    }

    .topor {
        text-align: center;
        padding: 6px 0;
        border-bottom: 1px solid #D9D9D9;
        font-weight: 600;
        font-size: 14px;
        color: #333333;
    }

    .botor {
        text-align: center;
        padding: 8px 0;
        font-size: 12px;
        color: #999999;
        line-height: 21px;
    }

    .ordernum {
        font-size: 14px;
        color: #999999;
        flex: 1;
        text-align: right;
    }

    .orderGoodsName {
        font-weight: 600;
        font-size: 14px;
        color: #666666;
        width: 240px;
        text-align: left;
    }

    .orderImage {
        width: 80px;
        height: 80px;
        margin-right: 10px;
    }

    .orderImage img {
        width: 100%;
        height: 100%;
        border-radius: 6px;
    }

    .orderContent {
        background: #fff;
    }

    .orderItems {
        margin-top: 21px;
        height: 780px;
        overflow-y: auto;
    }

    .orderTit {
        height: 32px;
        background: #F2F2F2;
        width: 100%;
        box-sizing: border-box;
        padding: 0 20px;
        font-weight: 500;
        font-size: 14px;
        color: #999999;
    }

    .orderItem {
        width: 99.8%;
        border: 1px solid #D9D9D9;
        margin-bottom: 20px;
    }

    .ordersContent {
        box-sizing: border-box;
    }

    .orderTitles {
        height: 32px;
        background: #F2F2F2;
        width: 100%;

    }

    .orderc1 {
        width: 464px;
        height: 128px;
        box-sizing: border-box;
        padding: 24px;
        border-right: 1px solid #D9D9D9;
    }

    .orderc2 {
        width: 124px;
        height: 128px;
        border-right: 1px solid #D9D9D9;
        display: flex;
        flex-direction: column;
        justify-content: center;
        box-sizing: border-box;
        padding: 20px;
    }

    .orderc3 {
        width: 157px;
        height: 128px;
        border-right: 1px solid #D9D9D9;
        display: flex;
        flex-direction: column;
        justify-content: center;
        box-sizing: border-box;
        padding: 20px;
    }

    .orderc4 {
        width: 176px;
        height: 128px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .orderTitle1 {
        width: 464px;
        text-align: center;
        font-weight: 500;
        font-size: 14px;
        color: #666666;
    }

    .orderTitle2 {
        width: 126px;
        text-align: center;
        font-weight: 500;
        font-size: 14px;
        color: #666666;
    }

    .orderTitle3 {
        width: 157px;
        text-align: center;
        font-weight: 500;
        font-size: 14px;
        color: #666666;
    }

    .orderTitle4 {
        width: 176px;
        text-align: center;
        font-weight: 500;
        font-size: 14px;
        color: #666666;
    }
</style>